module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/monitor-e740999d3886957dede7e328dec9c87c.svg";